var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConclusion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    rx: 25,
    fill: "url(#paint0_linear_9655_16854)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9655_16854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.4804 32.5971L53.4897 30.7753L56.9652 25.0703L59.9559 26.8921L56.4804 32.5971ZM65.5122 32.9576L59.6829 35.5896L61.1214 38.7781L66.9507 36.1461L65.5122 32.9576ZM55.8172 36.0201C57.1461 37.3195 58.2009 38.8723 58.9193 40.5865C59.6377 42.3008 60.0051 44.1416 59.9997 46.0003C59.9997 50.0166 58.2672 53.8421 55.2432 56.4986C53.8187 57.7533 52.9997 59.7063 52.9997 61.8606V67.0003H38.9997V61.6278C38.9997 59.6066 38.2069 57.7586 36.8227 56.5581C35.241 55.1923 33.9872 53.488 33.1541 51.5716C32.321 49.6551 31.93 47.5757 32.0102 45.4876C32.2709 38.1743 38.4414 32.1246 45.7617 32.0038C47.6214 31.9664 49.4696 32.3028 51.1969 32.993C52.9242 33.6832 54.4953 34.7114 55.8172 36.0201ZM49.4997 61.8623C49.4997 61.2288 49.5627 60.6093 49.6607 60.0021H42.3649C42.4454 60.5358 42.4997 61.0766 42.4997 61.6296V63.5021H49.4997V61.8623ZM56.4997 46.0021C56.504 44.608 56.2285 43.2273 55.6895 41.9416C55.1505 40.656 54.359 39.4916 53.3619 38.5173C52.3706 37.5355 51.1921 36.7629 49.8964 36.2452C48.6008 35.7276 47.2144 35.4754 45.8194 35.5038C40.3279 35.5948 35.7027 40.1308 35.5049 45.6136C35.4461 47.1793 35.7398 48.7383 36.3644 50.1752C36.989 51.6122 37.9284 52.8905 39.1134 53.9156C39.9552 54.6453 40.6517 55.5238 41.1924 56.5021H44.2462V49.1801C43.2255 48.8203 42.3412 48.1535 41.7145 47.2712C41.0879 46.3889 40.7496 45.3343 40.7462 44.2521H44.2462C44.2462 44.7162 44.4305 45.1613 44.7587 45.4895C45.0869 45.8177 45.532 46.0021 45.9962 46.0021C46.4603 46.0021 46.9054 45.8177 47.2336 45.4895C47.5618 45.1613 47.7462 44.7162 47.7462 44.2521H51.2462C51.2427 45.3343 50.9044 46.3889 50.2778 47.2712C49.6511 48.1535 48.7668 48.8203 47.7462 49.1801V56.5021H50.8384C51.3773 55.5104 52.085 54.6203 52.9297 53.8718C54.0493 52.8888 54.9465 51.6785 55.5614 50.3215C56.1764 48.9645 56.4951 47.4919 56.4962 46.0021H56.4997ZM38.5184 30.7753L35.0429 25.0703L32.0522 26.8921L35.5259 32.5971L38.5184 30.7753ZM26.4942 32.9576L25.0557 36.1461L30.8832 38.7781L32.3217 35.5896L26.4942 32.9576Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9655_16854",
    x1: 17,
    y1: 19,
    x2: 78,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5DCBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21AAE9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9655_16854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConclusion);
export default __webpack_public_path__ + "static/media/conclusion.5d2aceb6ece29b4f19cf5d4abb3a72c7.svg";
export { ForwardRef as ReactComponent };